import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";
import parse from "url-parse";
import _ from "underscore";
import capitalize from "underscore.string/capitalize";
import humanize from "underscore.string/humanize";
import titleize from "underscore.string/titleize";
import moment from "moment";
//actions
import { actions } from "actions/resources";
//antd
import { Switch, Button, Col, Table, Row } from "antd";
//utils

import ProgressiveImage from "react-progressive-image";
import defaultProfileImage from "images/default_profile.jpg";
//components
import CurrentJobForm from "./forms/current-job";
import DisciplinesForm from "./forms/disciplines";
import PostChallengeInterviewForm from "./forms/interview";

export class StudentInfo extends Component {
  state = {
    selectedCompany: null,
    selectedCompanyInfo: null,
    addEditFormVisible: false,
    infoFormVisible: false,
    studentsAlgolia: [],
    appliedChallenges: [],
    editStudentInfo: false,
    selectedProfile: null
  };

  componentWillMount() {
    this._fetchDependencies();
  }

  _fetchDependencies = async () => {
    const {
      fetchChallenges,
      fetchEducations,
      fetchInterviews,
      fetchProfile,
      fetchUser,
      fetchApplications,
      match
    } = this.props;

    if (match.path === "/students/edit/:id") {
      this.setState({ editStudentInfo: true });
    }

    if (match.params && match.params.id) {
      const profile = await fetchProfile(match.params.id);
      fetchUser(profile.payload.user_id);
      fetchInterviews({
        profile_id: match.params.id
      });
      fetchChallenges({});
      fetchApplications({ user_id: profile.payload.user_id });
      fetchEducations({
        user_id: profile.payload.user_id,
        primary: true
      });
    }
  };

  _studentPreview = async checked => {
    const { profile, redirect, updateProfile } = this.props;
    let companyIds = [];
    if (checked) {
      companyIds.push("*");
    }
    await updateProfile(profile.id, {
      user_id: profile.user_id,
      company_ids: JSON.stringify(companyIds)
    });
    redirect(`/students/${profile.id}`);
  };

  _topPerformer = async checked => {
    const { profile, redirect, updateProfile } = this.props;
    await updateProfile(profile.id, {
      user_id: profile.user_id,
      top_performer: checked
    });
    redirect(`/students/${profile.id}`);
  };

  _updateDisciplines = data => {
    const { profile, redirect, updateProfile } = this.props;
    let payload = {
      disciplines: JSON.stringify(data.disciplines.split(","))
    };

    updateProfile(profile.id, payload);
    redirect(`/students/${profile.id}`);
  };

  _updatePostChallengeInterview = async data => {
    const { createInterview, profile, redirect } = this.props;
    await createInterview({
      user_id: profile.user_id,
      profile_id: profile.id,
      company_name: data.interviews[0].company_name,
      offer_made: data.interviews[0].offer_made,
      offer_accepted: data.interviews[0].offer_accepted
    });

    redirect(`/students/${profile.id}`);
  };

  _updateProfile = async data => {
    const { profile, updateProfile, redirect } = this.props;
    await updateProfile(profile.id, data);
    redirect(`/students/${profile.id}`);
  };

  render() {
    let appliedChallenges, selectedProfileObject;
    const {
      challenges,
      applications,
      educations,
      profile,
      interviews,
      user
    } = this.props;
    const { editStudentInfo } = this.state;
    const currentEducation = educations[0] || null;
    if (profile) {
      appliedChallenges = _.filter(applications, function(e) {
        return e.user_id === profile.user_id;
      });
    }
    if (editStudentInfo) {
      selectedProfileObject = {
        interviews: interviews
      };
    }

    const postChallengesColumns = [
      {
        title: "Selected For Interviews",
        dataIndex: "company_name",
        align: "center",
        key: "company_name"
      },
      {
        title: "Offer Made",
        dataIndex: "offer_made",
        align: "center",
        key: "offer_made",
        render: (text, record) => {
          return <div>{text ? "Y" : "N"}</div>;
        }
      },
      {
        title: "Offer Accepted",
        dataIndex: "offer_accepted",
        align: "center",
        key: "offer_accepted",
        render: (text, record) => {
          return <div>{text ? "Y" : "N"}</div>;
        }
      }
    ];

    if (profile && user) {
      let profileImage = profile.image || defaultProfileImage;
      if (parse(profile.image).host === "www.wesolv.co") {
        profileImage = `https://legacy.wesolv.co${
          parse(profile.image).pathname
        }`;
      }

      return (
        <div>
          <Row className="detail-spacer">
            <Col span={4}>
              <ProgressiveImage
                src={profileImage}
                placeholder={defaultProfileImage}
              >
                {src => (
                  <div
                    alt="profile"
                    src={src}
                    style={{
                      backgroundPosition: "center",
                      backgroundImage: `url(${src})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      height: "100px",
                      width: "100px",
                      borderRadius: "50%",
                      paddingTop: "40px"
                    }}
                  />
                )}
              </ProgressiveImage>
            </Col>
            <Col span={20}>
              <Row type="flex" align="top">
                <Col span={12}>
                  <Row className="name">
                    {titleize(`${profile.first_name} ${profile.last_name}`)}
                  </Row>
                  <br />
                  <Row>
                    <span className="bold">LAST LOGIN DATE:&nbsp;</span>
                    {moment(user.last_login_at).format("M/D/YYYY")}
                  </Row>
                  <br />
                  <Row>
                    {profile.status === "active" ? (
                      <div className="active">ACTIVE</div>
                    ) : (
                      <div className="deactive">DEACTIVATED</div>
                    )}
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col span={4} offset={2}>
                      {editStudentInfo ? null : (
                        <Link to={`/students/edit/${profile.id}`}>
                          <Button type="primary">Edit Page</Button>
                        </Link>
                      )}
                    </Col>
                    <Col span={4} offset={4}>
                      <a
                        href={`${process.env.REACT_APP_WEB_URL}/profiles/${
                          profile.id
                        }`}
                      >
                        <Button type="primary">Profile Page </Button>
                      </a>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br />
              <Row>
                {currentEducation ? (
                  <Col span={8}>{currentEducation.university}</Col>
                ) : null}
                {currentEducation ? (
                  <Col span={8}>
                    {titleize(humanize(currentEducation.concentration))}
                  </Col>
                ) : null}
              </Row>
              <Row>
                {currentEducation ? (
                  <Col span={8}>
                    {titleize(humanize(currentEducation.program))},{" "}
                    {currentEducation.end_year}
                  </Col>
                ) : null}
                <Col span={8}>
                  {currentEducation
                    ? titleize(humanize(currentEducation.concentration_2))
                    : null}
                </Col>
              </Row>
            </Col>
          </Row>
          <div className="divider-line" />
          <Row className="detail-spacer">
            <Col span={20} offset={4}>
              <Row>
                <Col span={8}>
                  <h3 className="bold"> User Details</h3>
                </Col>
              </Row>
              <br />
              <Row justify="center" align="middle">
                <Col span={12}>
                  <span className="bold">SignUp Date:&nbsp;</span>
                  {moment(user.created_at).format("M/D/YYYY")}
                </Col>
                <Col span={12}>
                  <span className="bold">Validated Email:&nbsp;</span>
                  {user.email_verified_at ? "Y" : "N"}
                </Col>
              </Row>
              <br />
              <Row>
                <Col span={12}>
                  <span className="bold">Email: </span>
                  {user.email}
                </Col>
                <Col span={12}>
                  <span className="bold">LinkedIn:&nbsp;</span>
                  {profile.linkedin ? "Y" : "N"}
                </Col>
              </Row>
            </Col>
          </Row>
          <div className="divider-line" />
          <Row className="detail-spacer">
            <Col span={20} offset={4}>
              <Row>
                <Col span={12}>
                  <h3 className="bold">Challenges</h3>
                </Col>
              </Row>
              <br />
              <Row justify="center" align="middle">
                <Col span={12}>
                  <span className="bold">Applied to following challenges:</span>
                </Col>
                <Col span={12}>
                  <span className="bold">Accepted to challenge?:</span>
                </Col>
              </Row>
              <br />
              <Row>
                {appliedChallenges.length ? (
                  <div>
                    {appliedChallenges.map((appliedChallenge, i) => {
                      let challenge = _.findWhere(challenges, {
                        id: appliedChallenge.challenge_id
                      });
                      return (
                        <Col key={i} span={12} offset={12}>
                          {challenge.name}
                        </Col>
                      );
                    })}
                  </div>
                ) : (
                  <div>
                    <Col span={12}>
                      <span>N/A</span>
                    </Col>
                    <Col span={12}>
                      <span>N/A</span>
                    </Col>
                  </div>
                )}
              </Row>
              <br />
              <br />
              <Row>
                <Col span={12}>
                  <span className="bold">Top Performer:&nbsp;</span>
                  {profile.top_performer ? "Y" : "N"}
                </Col>
              </Row>
            </Col>
          </Row>
          <div className="divider-line" />
          <Row className="detail-spacer">
            <Col span={20} offset={4}>
              <Row>
                <Col span={8}>
                  <h3 className="bold">Post Challenges</h3>
                </Col>
              </Row>
              <br />
              <Col span={24}>
                {editStudentInfo ? (
                  <PostChallengeInterviewForm
                    ref="PostChallengeInterviewForm"
                    initialValues={selectedProfileObject}
                    onSubmit={this._updatePostChallengeInterview}
                  />
                ) : (
                  <div>
                    <Table
                      columns={postChallengesColumns}
                      dataSource={interviews}
                      size="small"
                    />
                  </div>
                )}
              </Col>
            </Col>
          </Row>
          <div className="divider-line" />
          <Row className="detail-spacer">
            <Col span={20} offset={4}>
              <Row>
                <Col span="100%">
                  <h3 className="bold">Employment</h3>
                </Col>
                <br />
                {editStudentInfo ? (
                  <CurrentJobForm
                    initialValues={{
                      current_position: profile.current_position,
                      current_company: profile.current_company
                    }}
                    onSubmit={this._updateProfile}
                  />
                ) : (
                  <div>
                    <Col span="100%">
                      <span className="bold">Current Position: </span>
                      {profile.current_position || "N/A"}
                    </Col>
                    <br />
                    <Col span="100%">
                      <span className="bold">Current Company: </span>
                      {profile.current_company || "N/A"}
                    </Col>
                  </div>
                )}
              </Row>
            </Col>
          </Row>
          <div className="divider-line" />
          <Row className="detail-spacer">
            <Col span={20} offset={4}>
              <Row>
                <Col span="100%">
                  <h3 className="bold">Student Preview Settings</h3>
                </Col>
                <br />
                <Col span={12}>
                  <span className="bold">
                    <h3>Student Preview</h3>
                  </span>
                  <Switch
                    checked={
                      profile.company_ids && profile.company_ids.length
                        ? true
                        : false
                    }
                    onChange={v => this._studentPreview(v)}
                  />
                </Col>
                <Col span={12}>
                  <span className="bold">
                    <h3>Top Performer</h3>
                  </span>
                  <Switch
                    checked={profile.top_performer}
                    onChange={v => this._topPerformer(v)}
                  />
                </Col>
              </Row>
              <div style={{ marginBottom: "20px" }} />
              <Row>
                <Col span={24}>
                  <span className="bold">
                    <h3>Student Disciplines</h3>
                  </span>
                  {editStudentInfo ? (
                    <DisciplinesForm
                      initialValues={{
                        disciplines:
                          profile.disciplines && profile.disciplines.join(", ")
                      }}
                      onSubmit={this._updateDisciplines}
                    />
                  ) : (
                    <div>
                      {profile.disciplines
                        ? profile.disciplines.map((discipline, i) => {
                            if (i === 0) return `${capitalize(discipline)}`;
                            return `, ${titleize(discipline)}`;
                          })
                        : "N/A"}
                    </div>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      );
    }

    return null;
  }
}

export default connect(
  state => ({
    challenges: state.resources.collection.challenge || [],
    interviews: state.resources.collection.interview || [],
    applications: state.resources.collection.application || [],
    educations: state.resources.collection.education || [],
    students: state.resources.collection.profile || [],
    profile: state.resources.detail.profile,
    user: state.resources.detail.user
  }),
  dispatch => ({
    fetchChallenges: bindActionCreators(actions.fetchChallenges, dispatch),
    createInterview: bindActionCreators(actions.createInterview, dispatch),
    updateJob: bindActionCreators(actions.patchJob, dispatch),
    fetchApplications: bindActionCreators(actions.fetchApplications, dispatch),
    fetchInterviews: bindActionCreators(actions.fetchInterviews, dispatch),
    fetchEducations: bindActionCreators(actions.fetchEducations, dispatch),
    fetchProfiles: bindActionCreators(actions.fetchProfiles, dispatch),
    fetchProfile: bindActionCreators(actions.fetchProfile, dispatch),
    fetchUser: bindActionCreators(actions.fetchUser, dispatch),
    submitForm: bindActionCreators(submit, dispatch),
    redirect: bindActionCreators(push, dispatch),
    updateProfile: bindActionCreators(actions.patchProfile, dispatch)
  })
)(StudentInfo);



// WEBPACK FOOTER //
// ./src/components/dashboard/student/detail.js